import IResponse = ZoneIQCalibration.IResponse;
import { environment } from '../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import * as _ from 'lodash';
import { CalibrationOfficeCommercialValue } from '../../models';

const API = environment.ZONEIQ_CALIBRATION + '/v1/calibration-office-commercial';

@Injectable({
    providedIn: 'root'
})
export class CalibrationOfficeCommercialService {
    constructor(private readonly http: HttpClient) {}

    saveChanges(calibrationOfficeCommercialData: CalibrationOfficeCommercialValue[]) {
        if (!_.get(calibrationOfficeCommercialData, 'length', 0)) {
            return;
        }
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const params = new HttpParams().append('syncChanges', 'true');

        return this.http.post<IResponse>(API, calibrationOfficeCommercialData, { headers, params });
    }
}
